import React, { lazy, Suspense, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
const About = lazy(() => import('./pages/About'));
const Products = lazy(() => import('./pages/Products'));
const Pricing = lazy(() => import('./pages/Pricing'));
const Contact = lazy(() => import('./pages/Contact'));
const Terms = lazy(() => import('./pages/Terms'));
const Privacy = lazy(() => import('./pages/Privacy'));
const IpPolicy = lazy(() => import('./pages/IpPolicy'));
const Blog = lazy(() => import('./pages/Blog'));
const BlogPost = lazy(() => import('./pages/BlogPost'));

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="flex flex-col min-h-screen">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[60] focus:bg-white focus:text-primary focus:px-4 focus:py-2 focus:rounded-md focus:shadow-lg">
        {t('header.skipToContent')}
      </a>
      <Header />
      <main id="main" tabIndex={-1} className="flex-grow focus:outline-none">
        <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/ip-policy" element={<IpPolicy />} />
        </Routes>
        </Suspense>
      </main>
      <Footer />
      <a
        href="https://api.whatsapp.com/send?phone=5217294441897&text=Hola%2C%20m%C3%A1s%20informaci%C3%B3n%20por%20favor"
        target="_blank"
        rel="noopener noreferrer"
        aria-label={t('whatsapp.contact')}
        title={t('whatsapp.contact')}
        className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-lg transition hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
      >
        <svg
          viewBox="0 0 32 32"
          className="h-7 w-7"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M19.11 17.33c-.27-.14-1.57-.77-1.82-.86-.25-.09-.43-.14-.61.14-.18.27-.7.86-.86 1.04-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.19-1.34-.81-.72-1.36-1.61-1.52-1.88-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.14-.16.18-.27.27-.45.09-.18.04-.34-.02-.48-.07-.14-.61-1.48-.84-2.03-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.52-.01-.18 0-.48.07-.73.34-.25.27-.95.93-.95 2.27 0 1.34.98 2.64 1.11 2.82.14.18 1.93 2.95 4.68 4.14.65.28 1.16.45 1.56.58.65.21 1.25.18 1.72.11.52-.08 1.57-.64 1.79-1.26.22-.61.22-1.14.16-1.26-.07-.12-.25-.2-.52-.34zm-3.05 11.24c-2.11 0-4.17-.55-5.99-1.59L4 28l1.73-5.77C4.63 20.29 4.05 18.18 4.05 16c0-6.6 5.37-11.95 11.98-11.95S28 9.4 28 16c0 6.6-5.37 11.95-11.94 11.95zm0-25.7C8.89 2.87 3.05 8.7 3.05 16c0 2.34.61 4.62 1.78 6.63L3 28.95l6.5-1.71c1.94 1.18 4.16 1.8 6.56 1.8 7.17 0 13-5.83 13-13.04s-5.83-13.13-12.99-13.13z" />
        </svg>
      </a>
    </div>
  );
}

export default App;
